import React from 'react';
import './Terms.css';

function Terms() {
  return (
    <div className="terms-page">
      <h1>Terms of Service</h1>
      <p className="terms-last-updated">Last updated: April 2026</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By using Yardray, you agree to these terms. If you don't agree, please don't use the service.</p>
      </section>

      <section>
        <h2>2. User Accounts</h2>
        <ul>
          <li>You must be 18+ to use this service</li>
          <li>You're responsible for your account security</li>
          <li>One account per person</li>
          <li>Keep your password secure</li>
        </ul>
      </section>

      <section>
        <h2>3. User Content</h2>
        <ul>
          <li>You retain ownership of your photos and data</li>
          <li>You grant us license to store and display your content to provide the service</li>
          <li>Only upload photos you took yourself</li>
          <li>We may remove content if we become aware of violations</li>
        </ul>
      </section>

      <section>
        <h2>4. Service Availability</h2>
        <ul>
          <li>We provide the service "as is" without warranties</li>
          <li>No guarantee of 100% uptime</li>
          <li>We may modify or discontinue features without notice</li>
          <li>We'll do our best to keep your data safe with automated backups</li>
        </ul>
      </section>

      <section>
        <h2>5. Privacy</h2>
        <p>See our <a href="/privacy">Privacy Policy</a> for how we handle your data.</p>
        <ul>
          <li>We don't sell your data</li>
          <li>We use tokens for authentication only</li>
          <li>Your photos are private to your account</li>
        </ul>
      </section>

      <section>
        <h2>6. Prohibited Uses</h2>
        <p>You may not:</p>
        <ul>
          <li>Use the service for spam or abuse</li>
          <li>Upload malicious code or viruses</li>
          <li>Attempt to hack or break the service</li>
          <li>Share your account with others</li>
          <li>Use automated bots without permission</li>
        </ul>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <ul>
          <li>We're not responsible for crop failures, bad gardening outcomes, or plant deaths</li>
          <li>Use all gardening advice at your own risk</li>
          <li>AI-generated advice is for informational purposes only</li>
          <li>Always verify plant identification before consuming anything</li>
          <li>Our maximum liability to you is limited to the amount you paid us, if any</li>
        </ul>
      </section>

      <section>
        <h2>8. Termination</h2>
        <ul>
          <li>We can terminate accounts for terms violations</li>
          <li>You can delete your account anytime from Settings</li>
          <li>Upon account deletion, your data will be deleted within 30 days</li>
          <li>Backup copies may persist for up to 90 days after deletion</li>
          <li>You can export your data before deletion</li>
        </ul>
      </section>

      <section>
        <h2>9. Changes to Terms</h2>
        <ul>
          <li>We may update these terms without notice</li>
          <li>Continued use after changes constitutes acceptance</li>
          <li>Major changes will be emailed to users</li>
        </ul>
      </section>

      <section>
        <h2>10. Intellectual Property</h2>
        <ul>
          <li>Yardray name, logo, and code are our property</li>
          <li>You can't copy, modify, or resell the service</li>
          <li>Open source components retain their original licenses</li>
        </ul>
      </section>

      <section>
        <h2>11. Contact</h2>
        <p>Questions about these terms? Contact us at: <a href="mailto:hello@yardray.app">hello@yardray.app</a></p>
      </section>
    </div>
  );
}

export default Terms;